import { createGlobalStyle } from "styled-components";

const GlobalStyles = createGlobalStyle`
  *,
  *::after,
  *::before {
    box-sizing: inherit;
    margin: 0;
    padding: 0;
    scroll-behavior: smooth;
  }

  :root {
    --primary: #5A0E1B;
    --secondary: #EDEAE6;
    --accent: #7C0E33;
    --accent-dark: #5A0E1B;
    --accent-light: #EFDBCB;
    --background: #EDEAE6;
    --surface: #ffffff;
    --text-primary: #2c2c2c;
    --text-secondary: #6b6b6b;
    --text-muted: #9d9d9d;
    --success: #5FAF6B;
    --warning: #E6B756;
    --error: #D55A6A;
    --info: #4A90E2;
    --gradient-primary: linear-gradient(135deg, #5A0E1B 0%, #7C0E33 100%);
    --gradient-secondary: linear-gradient(135deg, #EDEAE6 0%, #ffffff 100%);
    --shadow-soft: 0 8px 32px rgba(124, 14, 51, 0.15);
    --shadow-medium: 0 12px 40px rgba(124, 14, 51, 0.25);
  }

  /* Firefox */
  * {
    scrollbar-width: thin;
    scrollbar-color: rgba(124, 14, 51, 0.35) transparent;
  }

  /* Chrome, Edge, and Safari */
  *::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  *::-webkit-scrollbar-track {
    background: transparent;
  }

  *::-webkit-scrollbar-thumb {
    background-color: rgba(124, 14, 51, 0.35);
    border-radius: 8px;
  }

  *::-webkit-scrollbar-thumb:hover {
    background-color: rgba(124, 14, 51, 0.55);
  }

  body {
    color: var(--text-primary);
    font-family: "Montserrat", sans-serif;


    line-height: 1.6;
    background: var(--secondary);
    overflow-x: hidden;
  }

  html {
    height: 100%;
    box-sizing: border-box;
    /* iOS Safari ignoriše overflow-x: hidden na body ako ga nema i na html —
       bez ovoga stranica na telefonu dobija horizontalni skrol */
    overflow-x: hidden;

    font-size: 93.75%; /* 15px / 16px = 0.9375 */

    @media screen and (max-width: 960px) {
      font-size: 81.25%; /* 13px */
    }

    @media screen and (max-width: 400px) {
      font-size: 75%; /* 12px */
    }
  }

  /* Visible focus indicator for keyboard navigation */
  :focus-visible {
    outline: 2px solid var(--accent);
    outline-offset: 2px;
  }

  :focus:not(:focus-visible) {
    outline: none;
  }

  /* Disable selection only on protected media, not on text content */
  video,
  img {
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  /* Disable drag for images */
  img {
    -webkit-user-drag: none;
    -khtml-user-drag: none;
    -moz-user-drag: none;
    -o-user-drag: none;
    user-drag: none;
    pointer-events: none;
  }

  ::selection {
    background: rgba(124, 14, 51, 0.25);
  }

  ::-moz-selection {
    background: rgba(124, 14, 51, 0.25);
  }
`;

export default GlobalStyles;
